export default function CoherentBookings(CoherentBookingFactory) {
    var fn = this;

    fn.combinedBookings = CoherentBookingFactory.combinedBookings;

    fn.uniteBookings = function () {
        CoherentBookingFactory.uniteBookings();
    };

    return fn;
}
